var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { class: _vm.classes.list },
    _vm._l(_vm.options, function(option) {
      return _c(
        "li",
        { class: _vm.classes.listItem },
        [
          _c(_vm.optionComponent, {
            tag: "component",
            attrs: {
              "is-active": _vm.value == option.id,
              id: option.id,
              label: option.label,
              image: option.image,
              icon: option.icon,
              color: option.color
            },
            on: { select: _vm.handleSelectItem }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }